import React from 'react';

const NotificationConnectedIcon = ({ size = 20 }) => {
  return (
    <svg t="1600985802995" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15798" width={size} height={size}>
      <path d="M512 128c182.784 0 350.72 63.872 482.56 170.496L512 896 29.44 298.538667A764.458667 764.458667 0 0 1 512 128z" p-id="15799" fill="#0341B6" />
    </svg>
  );
};

export default NotificationConnectedIcon;
